import React, {memo, useState} from 'react';
import { LineItemsStore } from '../../../platform/ps-models/lineitems-store/LineItemsStore';
import { LineItemsTableWithFormulas } from '../../../platform/lineitems-store/LineItemsTableView';
import { AggregateOver, StoreQuery } from '../../../platform/ps-models/lineitems-store';
import { TimeSeriesChartV2 } from '../../lineitems-store/TimeSeriesChartV2';
import {Checkbox, Segment} from "semantic-ui-react";
import { Metric } from '../../statistics/Metric';
import { values } from 'ramda';
import { ClosableSection } from '../../ClosableSection';
import { AggregatorMethod } from '../../ps-models/line-item-utils/aggregators';
import { normalizeString } from '../../ps-models/line-item-utils/coding.utils';
export interface AIVisualizationProps {
  store: LineItemsStore;
  title: string;
  type: 'table' | 'line' | 'bar' | 'metrics' | 'select' | 'compare';
  aggregations?: Record<string, string>;
  visualization?: any,
}

export const AIVisualization: React.FC<AIVisualizationProps> = memo(({ store, title, type, aggregations, visualization }) => {


  let [totalsOnly, setTotalsOnly] = useState(true);

  if(type === 'metrics') {

    console.info("Aggregations", aggregations);
    let {start, end} = store.timeIndex.getRange();
    let results = store.query(StoreQuery.all(), {
      aggregatedTable: {
        defaultAggregateOver: AggregateOver.TIME_INDEX,
        lineItemAggregations: {
          lineItemMap: aggregations as Record<string, AggregatorMethod>,
          defaultAggregator: "sum"
        },
        currentRange: {
          start, end
        }
      }
    });

    let fullResults = store.query(StoreQuery.all());

    return (<div>
    {aggregations && Object.keys(aggregations).map((lineItem) => (<>
      <Metric label={ lineItem }
      value={ results.lastTimeSlotTextOf(lineItem) }
      />
    </>))}
  
    <ClosableSection
      title="Line Items"
      opened={false}
      level='title-bar' >

        <LineItemsTableWithFormulas
          withGroups={true}
          store={store}
          queryResult={fullResults}
        />
      </ClosableSection>

    </div>);

  } 

  else if (type === 'select') {
    return (<div>
      <SelectVisualization store={store} title={title} visualization={visualization} />
    </div>);
  }
  
  else if (type === 'line' || type === 'bar') {

    let results;

    if(totalsOnly) {
      results = store.query(StoreQuery
        .byNames(visualization.lineItems).or(StoreQuery.withField('store_groupingName')));
    } else {
      results = store.query(StoreQuery.all());
    }
    

    return (<div>
        <Checkbox
          label='Show totals only'
          checked={totalsOnly}
          onChange={() => setTotalsOnly(!totalsOnly)}
        />
      <TimeSeriesChartV2
        title={""}
        options={{
          type,
          granularity: store.timeIndex.getUnit(),
          plotAtLastDatesOfPeriod: true
        }}
        result={results}
      />
      
      <ClosableSection
      title="Line Items"
      opened={false}
      level='title-bar' >

        <LineItemsTableWithFormulas
          withGroups={true}
          store={store}
          queryResult={results}
        />
      </ClosableSection>
      </div>

    );
  }

  if(type === 'compare') {
    let {start, end} = store.timeIndex.getRange();

    let results = store.query(StoreQuery.all(), {
      aggregatedTable: {
        defaultAggregateOver: AggregateOver.TIME_INDEX,
        lineItemAggregations: {
          lineItemMap: {
            [visualization.leftMetric.lineItemName]: visualization.leftMetric.aggregation,
            [visualization.rightMetric.lineItemName]: visualization.rightMetric.aggregation
          },
          defaultAggregator: "sum"
        },
        currentRange: {
          start, end
        }
      }
    });

    let fullResults = store.query(StoreQuery.all());

    const { leftMetric, rightMetric } = visualization;
    
    return (<div>
      <div style={{ display: 'flex', gap: '2rem', justifyContent: 'center', padding: '1rem' }}>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <Metric 
            label={leftMetric.lineItemName}
            value={results.lastTimeSlotTextOf(leftMetric.lineItemName)}
          />
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <Metric 
            label={rightMetric.lineItemName}
            value={results.lastTimeSlotTextOf(rightMetric.lineItemName)}
          />
        </div>
      </div>
      <ClosableSection
      title="Line Items"
      opened={false}
      level='title-bar' >

        <LineItemsTableWithFormulas
          withGroups={true}
          store={store}
          queryResult={fullResults} 
        />
      </ClosableSection>
      </div>
    );
  }

  const results = store.query(StoreQuery.all());
  // Default to table view
  return (
    <LineItemsTableWithFormulas
      withGroups={true}
      store={store}
      queryResult={results}
    />
  );
});

interface SelectVisualizationProps {
  store: LineItemsStore;
  title: string;
  visualization: any;
}

const SelectVisualization = ({ store, title, visualization }: SelectVisualizationProps) => {

  console.info(visualization);

  let {start, end} = store.timeIndex.getRange();
  let groupBy = visualization.groupBy as string;
  let selectOperation = visualization.selectOperation as "min" | "max";
  let timeAggregation = visualization.timeAggregation as "sum" | "avg" | "first" | "last";

  let results = store.query(StoreQuery.all(), {
    aggregatedTable: {
      defaultAggregateOver: AggregateOver.TIME_INDEX,
      currentRange: {
        start, end
      }
    }
  });

  let groupByField = `fields.source_${normalizeString(groupBy).toLowerCase()}`;

  console.info("Group By", groupByField);
  console.info("Results", results);
  console.info("source", results.getRowsBy(groupByField));

  //Select by selectOperation
  let rowsByGroup = results.getRowsBy(groupByField);

  let valuesByGroup: Record<string, {value: number, text: string}> = {};


  Object.entries(rowsByGroup).forEach(([group, rows]) => {
    let values: number[] = rows.map((row) => {
      return row["0"].value as number;
    });
    
    valuesByGroup[group] = {value: rows[0]["0"].value as number, text: rows[0]["0"].text as string};
    
  });

  console.info(valuesByGroup);

//Sort valuesByGroup by value

  let sortedValuesByGroup;
  if(selectOperation === "min") {
    sortedValuesByGroup = Object.entries(valuesByGroup).sort((a, b) => a[1].value - b[1].value);
  } else {
    sortedValuesByGroup = Object.entries(valuesByGroup).sort((a, b) => b[1].value - a[1].value);
  }
    
  return <div>
    <div>
      {sortedValuesByGroup.slice(0, 1).map(([group, value]) => (
        <div>

          <Metric label={group} value={value.text} />
        </div>
      ))}
    </div>

    <ClosableSection title="Line Items" opened={false} level='title-bar' >
        <LineItemsTableWithFormulas
          withGroups={true}
          store={store}
          queryResult={results}
        />
      </ClosableSection>

  </div>
};